import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=739a29fd&scoped=true"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"
import style0 from "./Compose.vue?vue&type=style&index=0&id=739a29fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739a29fd",
  null
  
)

export default component.exports